import { render, staticRenderFns } from "./ListPassed.vue?vue&type=template&id=7525baf8&"
import script from "./ListPassed.vue?vue&type=script&lang=js&"
export * from "./ListPassed.vue?vue&type=script&lang=js&"
import style0 from "./ListPassed.vue?vue&type=style&index=0&id=7525baf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports